import styled, { css } from 'styled-components';
import { rem } from 'polished';

import Icon from '@atresmedia/intranet-icon';

const StyledPillImg = styled(Icon)`
  display: none;
  @media (min-width: ${props => props.theme.mediaqueries.tablet}) {
    display: block;
    width: ${rem('40px')};
    margin: 0 auto ${rem('10px')};
    height: ${rem('40px')};
  }
`;

const StyledPillIcon = styled(Icon)`
  background: transparent;
  width: ${rem('20px')};
  height: ${rem('20px')};
  cursor: pointer;
  position: relative;
`;

const WrapperIcon = styled.div`
  width: ${rem('20px')};
  height: ${rem('20px')};
  cursor: pointer;
  border: ${rem('2px')} solid ${props => props.theme.colors.dark_1};
  border-radius: 50%;
  margin-left: ${rem('6px')};
  @media (min-width: ${props => props.theme.mediaqueries.desktop}) {
    position: relative;
    top: ${rem('-8px')};
    right: ${rem('-35px')};
    margin-left: 0;
  }
  &:hover {
    background-color: ${props => props.theme.colors.dark_1};
    border-color: ${props => props.theme.colors.dark_1};
    ${StyledPillIcon} {
      fill: white;
    }
  }
`;

const WrapperIconToogle = styled(WrapperIcon)`
  right: ${rem('9px')};
  top: ${rem('15px')};
  position: relative;
  display: inline-block;
  @media (min-width: ${props => props.theme.mediaqueries.desktop}) {
    margin-left: 0;
  }
`;

const StyledPillText = styled.h2`
  font-size: ${rem('16px')};
  font-family: ${props => props.theme.fonts.medium};
  color: ${props => props.theme.colors.dark_2};
  margin: 0;
  font-weight: initial;
  @media (min-width: ${props => props.theme.mediaqueries.desktop}) {
    margin: 0 ${rem('20px')} ${rem('25px')};
    font-size: ${rem('18px')};
    font-family: ${props => props.theme.fonts.regular};
  }
`;

const StyledPill = styled.div`
  padding: ${rem('25px')};
  background-color: ${props => props.theme.colors.light};
  border: ${rem('1px')} solid ${props => props.theme.colors.grayLight};
  text-align: center;
  position: relative;
  width: ${rem('180px')};
  height: ${rem('200px')};
  display: flex;
  align-items: center;
  margin-bottom: ${rem('22px')};
  transition: all 0.3s ease-in-out;
  &:hover {
    // background-color: ${props => props.theme.colors.primary};
    // cursor: pointer;
    ${StyledPillText} {
      color: ${props => props.theme.colors.dark};
      cursor: pointer;
    }
  }

  ${props =>
    props.featured &&
    css`
      background-color: ${props => props.theme.colors.dark_8};
      border: ${rem('1px')} solid ${props => props.theme.colors.dark_4};
    `};
  @media (min-width: ${props => props.theme.mediaqueries.desktop}) {
    padding: ${rem('40px')} ${rem('30px')};
  }
`;

const StyledPillsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-items: center;
  padding: 0 ${rem('20px')};
  @media (min-width: ${props => props.theme.mediaqueries.desktop}) {
    padding: ${rem('60px')} ${rem('30px')} 0 ${rem('30px')};
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }
`;

export {
  StyledPill,
  StyledPillImg,
  StyledPillIcon,
  StyledPillText,
  StyledPillsWrapper,
  WrapperIcon,
  WrapperIconToogle
};
